"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _QuizService = require("./QuizService");

var _QuizActions = _interopRequireDefault(require("../actions/QuizActions"));

// import Reflux from 'reflux';
// import {showAlert} from '../../../../helpers/AlertHelper';
// import GameService from './GameService';
var QuestionSetService = {
  levels: [],

  /* unused */
  // preload(levelId) {
  //   return getLevel(levelId).then((loadedLevel) => {
  //     console.log('successfully got level: ', loadedLevel);
  //     this.levels.push(loadedLevel);
  //     return Promise.resolve(loadedLevel.value);
  //   }, (error) => {
  //     console.log('error loading level', error);
  //     showAlert('Fehler beim Laden der Level');
  //     Promise.resolve(null);
  //   });
  // },
  preloadCurrentLevel: function preloadCurrentLevel(user) {
    var _this = this;

    return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var loadedLevels;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, _QuizService.getCurrentLevel)(user);

            case 3:
              loadedLevels = _context.sent;

              if (!(loadedLevels.length === 0)) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", _promise["default"].resolve(null));

            case 6:
              console.log('successfully got level: ', loadedLevels);
              _this.levels = _this.levels.concat(loadedLevels);

              _QuizActions["default"].setCurrentLevel({
                level: loadedLevels[0].value
              });

              return _context.abrupt("return", _promise["default"].resolve(loadedLevels[0].value));

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              console.log('error loading  current level', _context.t0); // TODO how to handle showNoMoreAlerts(); ?

              return _context.abrupt("return", _promise["default"].resolve(null));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 12]]);
    }))();
  },
  get: function get(levelId) {
    var returnValue = null; // TODO: check if this.levels is an array on which some() can be applied to.

    (0, _values["default"])(this.levels).some(function (level) {
      if (!level.value) {
        throw new Error('something expected is not defined');
      }

      if (level.value.emsId === levelId) {
        returnValue = level.value;
        return true;
      }

      return false;
    });
    return returnValue;
  }
};
var _default = QuestionSetService;
exports["default"] = _default;